export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 3-2_10.0c2ac85e.jpg";